import React, { useState, useEffect } from 'react';
import { LIST_STATE_KEYS } from '../../config/listStateKeys';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useDispatch, useStore } from 'react-redux';
import { ListStateAction } from '../../actions/ListStateAction';
import { readPriorityFilter, buildPrioritySnapshotPatch } from '../../lib/listPriorityFilter';
import CustomHeader from '../../components/common/CustomHeader';
import { ServiceConstant } from '../../actions/constants/ServiceConstant';
import { RayTable, RayTreeview, AdminServiceListHeader } from '../../components/common';
import { ServiceAction } from '../../actions/ServiceAction';
import { ProgramConstant } from '../../actions/constants/ProgramConstant';
import { Loading } from '../../components/common/Loading';
import { ModalConfirm } from '../../components/common/ModalConfirm';
import { AdminUserAction, CustomFieldAction, } from '../../actions';
import DeepSearch from '../../components/common/DeepSearch';
import { Translate as t } from '../../config/Translate';
import { SERVICE_STATUS } from '../../config/ServiceConstants';
import { applyHeaderPrefs } from '../../lib/headerPrefs';
import { buildDeepSearchMatch } from '../../lib/deepSearchMatch';

export const computeServiceExHeader = (user, dfilters, baseHeaderNames) => {
	const services = user?.adminheaders?.services;
	const bases = Array.isArray(baseHeaderNames) ? baseHeaderNames : [];
	return services ? services.filter(x => (Array.isArray(dfilters) ? dfilters : []).map(m => m.code).includes(x.name) && !bases.includes(x.name)) : [];
};

const AdminServiceList = ({ customs, user, users, GetServiceAll, services, totalservicecount, filterOptions, filterDateOptions,
	dsfilters, UpdateStatusBulk, companies, viewTree, GetUserAll, servicematch, UpdatePriority }) => {

	const [bulkList, setBulkList] = useState([]);
	const [bulkIng, setBulkIng] = useState(false);
	const [bulkCnt, setbulkCnt] = useState(0);
	const [action, setAction] = useState("");
	const [exheader, setExHeader] = useState([]);

	const [wHg, setwHg] = useState(300);
	const [wAll, setwAll] = useState(window.innerWidth);
	const [filterCompanyId, setFilterCompanyId] = useState("");
	const [filterCompany, setFilterCompany] = useState({ name: "ALL" });

	const [header, setHeader] = useState([]);
	const [showCHModal, setShowCHModal] = useState(false);

	const [nowuserfilter, setnowuserfilter] = useState({});
	const [filters, setFilters] = useState([]);
	const [filterData, setFilterData] = useState([]);
	const [showDSModal, setShowDSModal] = useState(false);
	const [match, setMatch] = useState({});
	const [actioninfo, setActionInfo] = useState({});
	const [ready, setReady] = useState(false);
	const [dfilters, setdFilters] = useState(false);

	const [service, setService] = useState([]);
	const dispatch = useDispatch();
	const store = useStore();
	// BUG-257: 화면 복귀 시 RayTable 이 스냅샷 filterpage 를 복원하므로 칩 초기값도 스냅샷에서 읽는다.
	const [priorityFilter, setPriorityFilterState] = useState(() => readPriorityFilter(store.getState()?.ListStateReducer?.[LIST_STATE_KEYS.ADMIN_SERVICE], 'priority'));
	// 칩 변경 시 RayTable 재마운트 전에 스냅샷 priority 를 새 값으로 맞춘다(안 맞추면 복원이 새 값을 덮어씀).
	const setPriorityFilter = (next) => {
		const patch = buildPrioritySnapshotPatch(store.getState()?.ListStateReducer?.[LIST_STATE_KEYS.ADMIN_SERVICE], 'priority', next);
		patch && dispatch(ListStateAction.Save(LIST_STATE_KEYS.ADMIN_SERVICE, patch));
		setPriorityFilterState(next);
	};

	// Clear 버튼: 우선순위 칩을 All 로. 칩이 바뀌면 RayTable 이 key 로 재마운트되며 스냅샷을 복원하므로,
	// 복원이 옛 검색어·필터를 되살리지 않게 스냅샷도 함께 초기값으로 맞춘다(스냅샷 필드를 undefined 로 두면 RayTable 기본값 사용).
	//
	// deepSearchCleared — 같은 클릭에서 상세 검색을 비웠는지. true 면 스냅샷의 옛 match 도 {} 로 비운다.
	// 단 match 키가 없던 스냅샷에는 키를 만들지 않는다(RayTable 은 match 키가 없을 때만 토글 필터를 적용한다).
	const clearPriorityFilter = (deepSearchCleared = false) => {
		if (Object.keys(priorityFilter).length === 0) return;
		const saved = store.getState()?.ListStateReducer?.[LIST_STATE_KEYS.ADMIN_SERVICE]?.filterpage;
		if (saved && typeof saved === 'object') {
			const clearedMatch = deepSearchCleared && Object.prototype.hasOwnProperty.call(saved, 'match') ? { match: {} } : {};
			dispatch(ListStateAction.Save(LIST_STATE_KEYS.ADMIN_SERVICE, {
				filterpage: { ...saved, filters: {}, searchKey: '', filterDateOptions: [], page: 1, ...clearedMatch },
				currentPage: 1, skey: '', filters: undefined, datefilters: undefined,
			}));
		}
		setPriorityFilterState({});
	};

	useEffect(() => {
		user.adminType != "U" && updateViewTree(true);
	}, []);

	// IMP-283: UX 게이트 — 서비스 상태 변경은 adminType 'U' 차단. 최종 권한 강제는 BE(service.statusUpdate/Bulk → ES0403).
	const listAction = user?.adminType !== 'U'
		? [{ title: t('common.button.closeSelected'), action: "CLOSEALL" }]
		: [];

	const filterpage = {
		filters: { ...priorityFilter },
		filterOptions: [],
		filterDateOptions: filterDateOptions || [{ code: 'createDate', label: t('service.issueManager.createdDate') },],
		searchCols: ['summary', 'ticketKey', 'sn', 'site.sitename'],
		sort: { createDate: -1 },		
		searchKey: "",
		page: 1,
		itemperpage: user.settings?.dashboardtablelistcount || 30
	}

	const options = {
		isShowCheckBox: true,
		showClear: true,
		search: true,
		keyCol: 'ticketKey',
		defaultSort: Object.keys(filterpage.sort)[0],
		defaultSortType: Object.values(filterpage.sort)[0],
		linkto: '/Admin/AdminService',
		getList: GetServiceAll,
		linkkey: 'summary',
		filterpageoption: filterpage,
		filters: filterpage.filters,
		itemperpage: filterpage.itemperpage,
		useapi: true,
		totalitemcount: totalservicecount,
		filterOptions: filterOptions,
		defaultSort: "createDate",
		defaultSortType: -1,
	};

	useEffect(() => {
		setFilters(user.filters || []);
	}, [user.filters]);

	useEffect(() => {
		setReady(header.length > 0);
	}, [header]);

	useEffect(() => {
		const baseNames = Array.isArray(AdminServiceListHeader) ? AdminServiceListHeader.map(x => x?.name) : [];
		setExHeader(computeServiceExHeader(user, dfilters, baseNames));
	}, [user.adminheaders?.services, dfilters]);

	useEffect(() => {
		const originHeader = AdminServiceListHeader.filter(x => {
			return ((user.adminType == 'U' && (x.name != 'doa' && x.name != 'dim')) || (user.adminType != 'U' && x.name != 'installedDate'))
		}).filter(x => (user?.isMegagen || user?.companyId == 'RAY02091') ? x.name != 'exportcsr' : true).map(col =>
			col.name === 'priority'
				? {
					...col,
					options: {
						editable: true,
						func: (item, priority) => UpdatePriority(item._id, priority, user.adminid)
					}
				}
				: col
		);

		const composedHeader = exheader.length > 0 ? originHeader.concat(exheader) : originHeader;
		setHeader(applyHeaderPrefs(composedHeader, user?.adminheaders?.services));
	}, [exheader, user?.adminheaders?.services]);

	useEffect(() => {
		if (viewTree) {
			setwHg(300);
		} else {
			setwHg(0);
		}
	}, [viewTree]);

	useEffect(() => {
		callbackDs(dsfilters);
	}, [dsfilters]);

	useEffect(() => {
		setService(services.map(x => {
			return {
				...x,
				companyId: companies.filter(item => item.companyId == x.companyId).length == 1 ? companies.filter(item => item.companyId == x.companyId)[0].name : '',
				orgReplacement: x.replacements ? x.replacements : [],
				replacements: x.replacements ? x.replacements.map(z => `${z.title} (${z.oldsn} -> ${z.newsn})\n`) : [],
				creator: getUserName(x.creator),
				assignee: getUserName(x.assignee),
				installedDate: x.installedDate
			}
		}));
	}, [services]);

	const onChangeTreeviewItem = (item) => {
		setFilterCompanyId({ companyId: item.id });
		setFilterCompany(item);
	}

	const getWidth = () => setwAll(window.innerWidth);

	useEffect(() => {
		GetUserAll();
	}, []);

	const checkedList = (list) => {
		setBulkList(list);
	}

	const builk_UpdateStatus = () => {
		setActionInfo({ ...actioninfo, showModal: false });
		// BUG-058: ticketKey 중복 시 잘못된 문서 업데이트 방지 — _id 기반으로 전송
		const keyToId = new Map(services.map(s => [s.ticketKey, s._id]));
		const ids = bulkList.map(tk => keyToId.get(tk)).filter(Boolean);
		if (ids.length === 0) return;
		UpdateStatusBulk(ids, { status: SERVICE_STATUS.CLOSE });
	}

	const builk_ExportCCR = () => {
		setBulkIng(true);
		setActionInfo({ ...actioninfo, showModal: false });
	}

	const bulkActionDo = (action) => {
		switch (action) {
			case "CLOSEALL":
				setActionInfo({
					...actioninfo,
					title: t('common.label.closeSelectedService'), content: t('common.message.confirm.areYouSure'), showModal: true,
					actions: [
						{ title: t('common.label.updateAll'), callback: builk_UpdateStatus }
					]
				})
				break;
			case "EXPORTCCR":
				setActionInfo({
					...actioninfo,
					title: t('common.label.exportCCR'), content: t('common.message.confirm.areYouSure'), showModal: true,
					actions: [
						{ title: t('common.label.exportAll'), callback: builk_ExportCCR }
					]
				})
				break;
		}
		setAction(action);
	}

	const callbackDs = (filter) => {
		setMatch(buildDeepSearchMatch(filter));
	}

	// [모두 지우기]: 상세 검색 조건(리덕스)·저장 필터 선택도 초기화. 열린 상세 검색 창은 내부 filter state 가
	// dsfilters prop 을 따라가지 않으므로 닫아서 옛 조건이 남지 않게 한다. 조건이 이미 비었으면 dispatch 하지 않는다(재조회 방지).
	// 조건을 실제로 비웠을 때만 { match: {} } 를 돌려 RayTable 이 그 조건으로 한 번만 조회하게 한다.
	const clearDeepSearch = () => {
		setnowuserfilter({});
		setShowDSModal(false);
		if (!Array.isArray(dsfilters) || dsfilters.length === 0) return undefined;
		dispatch({ type: ServiceConstant.UPDATE_DSFILTER, dsfilters: [] });
		return { match: {} };
	}

	// clearPriorityFilter 는 칩이 비면 조기 return 하므로 상세 검색 초기화를 따로 먼저 부른다.
	const clearAll = () => {
		const result = clearDeepSearch();
		clearPriorityFilter(!!result);
		return result;
	}

	const toggle = [
		{ code: true, title: t('common.label.all'), filter: {} },
		{ code: false, title: t('service.label.notClosed'), filter: { 'status': { '$ne': SERVICE_STATUS.CLOSE } } }
	];

	const getMatchToggle = () => {
		const m = toggle.filter(x => JSON.stringify(x.filter) == JSON.stringify(servicematch));
		if (m.length > 0) {
			return m[0].code;
		}
		return false;
	}

	const defaultFilter = [
		//STRING, DATETIME, BOOLEAN
		{ code: "summary", name: t('common.label.summary'), type: "LIKESTRING" },
		{ code: "description", name: t('common.field.description'), type: "LIKESTRING" },
		{ code: "sn", name: t('product.field.serialNumber'), type: "STRING" },
		{ code: "status", name: t('common.label.status'), type: "STATUS" },
		{ code: "assignee", name: t('common.label.assignee'), type: "USER" },
		{ code: "companyId", name: t('user.type.operator'), type: "OPERATOR" },
		{ code: "category", name: t('service.field.claimCategory'), type: "CLAIM" },
		{ code: "creator", name: t('common.label.reporter'), type: "USER" },
		{ code: "effectiveDate", name: t('common.field.effectiveDate'), type: "DATETIME" },
		{ code: "errorCode", name: t('product.field.errorCode'), type: "STRING" },

		{ code: "comments.comment", name: t('common.field.comment'), type: "LIKESTRING" },

		{ code: "attachments.createDate", name: t('common.label.attachmentCreateDate'), type: "DATETIME" },

		{ code: "replacements.title", name: t('common.label.replacementPart'), type: "PARTLIST" },
		{ code: "replacements.sendDate", name: t('common.label.replacementDateSend'), type: "DATETIME" },
		{ code: "replacements.oldsn", name: t('common.label.replacementPartSnOld'), type: "STRING" },
		{ code: "replacements.newsn", name: t('common.label.replacementPartSnNew'), type: "STRING" },
		{ code: "replacements.trackingno", name: t('common.label.replacementPartTrackingNo'), type: "STRING" },

		{ code: "escalated", name: t('common.label.escalated'), type: "BOOLEAN" },
		{ code: "visitDate", name: t('service.field.visitDate'), type: "DATETIME" },
		{ code: "remoteDate", name: t('service.field.remoteDate'), type: "DATETIME" },
		{ code: "createDate", name: t('common.label.createDate'), type: "DATETIME" },
		{ code: "updateDate", name: t('common.label.lastUpdateDate'), type: "DATETIME" },
	]

	useEffect(() => {
		const newfilters = [];
		customs.filter(m => m.group.includes("SERVICE")).map(x => {
			if (x.valuetype == "FIXLIST") {
				const mList = [];
				x.listvals.map(l => mList.push({ code: l, title: l }));
				newfilters.push({ code: "customfieldvals." + x.code, type: x.valuetype, name: x.title, fixlist: mList });
			} else {
				newfilters.push({ code: "customfieldvals." + x.code, type: x.valuetype, name: x.title });
			}
		});
		defaultFilter.map(x => newfilters.push(x));
		setdFilters(newfilters);
	}, [customs]);

	const conSearch = () => {
		setShowDSModal(true);
	}

	const callbackchangeuserfilter = (data) => {
		setnowuserfilter(data);
		dispatch({ type: ServiceConstant.UPDATE_DSFILTER, dsfilters: data.filter ? [...data.filter] : [] });
	}

	const updateViewTree = (bl) => {
		dispatch({ type: ProgramConstant.VIEWTREE, val: bl });
	}

	const getUserName = (adminId) => {
		return users.filter(item => item.adminid == adminId).length == 1 ?
			users.filter(item => item.adminid == adminId)[0].firstName + ' ' + users.filter(item => item.adminid == adminId)[0].lastName : adminId;
	}

	return (
		<>
			<div className="extraHeader">
				<h2 className="mb-0">{t('service.title')}
					{companies.length > 1 && <button className="btn btn-secondary btn-sm mt-0 ms-1" onClick={() => updateViewTree(!viewTree)}>
						{filterCompany.name && <>
							{filterCompany.country && "[" + filterCompany.country + "] "}{filterCompany.name}
						</>}
					</button>}
				</h2>
				<div className="ray-right">
					<Link to="/Admin/AdminServiceAdd" className="btn btn-primary btn-sm mt-0">
						<ion-icon name="add-outline"></ion-icon>
						{t('service.button.addNew')}
					</Link>
					<button onClick={() => setShowCHModal(true)} className="btn btn-sm mt-0">
						<ion-icon name="options-outline"></ion-icon> {t('common.label.customHeaders')}
					</button>
					<Link to="/Admin/AdminServiceDashboard" className="btn btn-sm mt-0">
						<ion-icon name="desktop-outline"></ion-icon> {t('dashboard.title')}
					</Link>
				</div>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				{(viewTree && user.adminType != "U") &&
					<div className={viewTree ? "section fl p-0" : "section p-0 fl"} style={{ width: wHg }}>
						<div className='p-1'>
							<RayTreeview onClickItem={onChangeTreeviewItem} onResize={setwHg} stateKey={LIST_STATE_KEYS.ADMIN_SERVICE} />
						</div>
					</div>}
				<div className="section m-1 p-0">
					<div className="card p-2">
						<div className={user.adminType != "U" ? "fl" : ""} >
							{showDSModal && <div className="mb-1">
								<DeepSearch
									dispatchType={ServiceConstant.UPDATE_DSFILTER}
									extratrakey={"SERVICEEXTRAKEY"}
									extratrakeyname={"extradata"}
									savefiltertype={"service"}
									dsfilters={dsfilters || []}
									filterData={filterData}
									nowuserfilter={nowuserfilter}
									callbackDs={callbackDs}
									callbackchangeuserfilter={callbackchangeuserfilter}
									callbackDSClose={() => setShowDSModal(false)}
									defaultFilter={dfilters} />
							</div>}
							{(ready && !bulkIng) && <RayTable
								stateKey={LIST_STATE_KEYS.ADMIN_SERVICE}
								key={JSON.stringify(priorityFilter)}
								data={service}
								addFilter={filterCompanyId}
								ufilters={filters.length > 0 ? filters.filter(x => x.type == "service") : []}
								match={match}
								dsfilterCount={dsfilters.length}
								conSearch={conSearch}
								callbackchangeuserfilter={callbackchangeuserfilter}
								defaultFilter={defaultFilter}
								bulkActions={listAction}
								bulkActionDo={bulkActionDo}
								exportlocalaction={ServiceAction.GetServiceAllLocal}
								checkBoxCallback={(list) => checkedList(list)}
								columns={header}
								options={options}
								onClear={clearAll}
								listtype='service'
								toggle={toggle}
								toggleval={getMatchToggle()}
								headerSlot={<>
									{[
										{ code: null,       label: t('common.label.all'),      color: null },
										{ code: 'URGENT',   label: t('common.status.urgent'),   color: '#ef4444' },
										{ code: 'FAVORITE', label: t('common.status.favorite'), color: '#f59e0b' },
										{ code: 'NORMAL',   label: t('common.status.normal'),   color: '#22c55e' },
										{ code: '',         label: t('common.label.none'),  color: '#94a3b8' },
									].map(p => {
										const isActive = JSON.stringify(priorityFilter) === JSON.stringify(p.code === null ? {} : { 'priority': p.code });
										return (
											<button
												key={p.code === null ? 'all' : p.code === '' ? 'none' : p.code}
												onClick={() => setPriorityFilter(p.code === null ? {} : { 'priority': p.code })}
												style={{
													display: 'inline-flex',
													alignItems: 'center',
													gap: 5,
													padding: '3px 11px',
													borderRadius: 20,
													fontSize: 12,
													fontWeight: isActive ? 600 : 400,
													border: isActive ? 'none' : '1px solid #e2e8f0',
													background: isActive ? (p.color || '#334155') : '#f8fafc',
													color: isActive ? '#fff' : '#64748b',
													cursor: 'pointer',
													lineHeight: '20px',
												}}
											>
												{p.color && (
													<span style={{
														width: 7, height: 7,
														borderRadius: '50%',
														background: isActive ? 'rgba(255,255,255,0.75)' : p.color,
														flexShrink: 0,
													}} />
												)}
												{p.label}
											</button>
										);
									})}
								</>}
							/>}
							{bulkIng &&
								<div className="card">
									<div className="card-body pdB0">
										<div className="mt-3 mb-5 no-data">
											<Loading text={""} type="Circles" />
											<h2 className="mb-1">{actioninfo.title}</h2>
										</div>
									</div>
								</div>
							}
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
				<CustomHeader
					extratrakey={"SERVICEEXTRAKEY"}
					title={t('common.label.serviceListHeader')}
					extratrakeyname={"extradata"}
					exHeader={exheader}
					adminheaderprefix={"services"}
					showModal={showCHModal}
					callbackClose={() => setShowCHModal(false)}
					defaultFilter={dfilters || []}
					baseHeader={header} />
			</div>
			<ModalConfirm info={actioninfo} callbackClose={() => setActionInfo({ ...actioninfo, showModal: false })} />
		</>
	);
};

const mapState = (state) => {
	const services = state.ServiceReducer.services;
	const user = state.AuthReducer.user;
	const users = state.AdminUserReducer.users;
	const viewTree = state.ProgramReducer.viewtree;
	const companies = state.CompanyReducer.companies;
	const dsfilters = state.ServiceReducer.dsfilters;
	const totalservicecount = state.ServiceReducer.totalservicecount;
	const filterDateOptions = state.ServiceReducer.filterDateOptions;
	const filterOptions = state.ServiceReducer.filterOptions;
	const servicematch = state.ServiceReducer.servicematch;
	const customs = state.CustomFieldReducer.items;
	return { customs, user, users, services, totalservicecount, filterOptions, filterDateOptions, dsfilters, viewTree, companies, servicematch };
};

const mapDispatch = (dispatch) => ({
	//GetCustomAll: () => dispatch(CustomFieldAction.GetAll()),
	GetServiceAll: (filter) => dispatch(ServiceAction.GetServiceAll(filter)),
	UpdateStatusBulk: (ids, data) => dispatch(ServiceAction.UpdateStatusBulk(ids, data)),
	GetUserAll: () => dispatch(AdminUserAction.GetUserAll()),
	UpdatePriority: (serviceId, priority, who) => dispatch(ServiceAction.UpdatePriority(serviceId, priority, who)),
});

export default connect(mapState, mapDispatch)(AdminServiceList);
